// API endpoints for platforms
const API_URL = process.env.REACT_APP_API_URL;

// Fetch all platforms with pagination
export const fetchPlatforms = async (pageNumber = 1, size = 10) => {
  try {
    console.log(`Sending request to: ${API_URL}/Plateform/Pagination?Size=${size}&pageNumber=${pageNumber}`);
    const response = await fetch(`${API_URL}/Plateform/Pagination?Size=${size}&pageNumber=${pageNumber}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching platforms:', error);
    throw error;
  }
};

// Fetch a single platform by ID
export const fetchPlatform = async (id) => {
  try {
    const response = await fetch(`${API_URL}/plateform/byid/${id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching platform ${id}:`, error);
    throw error;
  }
};

// Create a new platform
export const createPlatform = async (platformData) => {
  try {
    const response = await fetch(`${API_URL}/plateform`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(platformData),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error creating platform:', error);
    throw error;
  }
};

// Update an existing platform
export const updatePlatform = async (id, platformData) => {
  try {
    const response = await fetch(`${API_URL}/plateform`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify({ ...platformData, id }),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error updating platform ${id}:`, error);
    throw error;
  }
};

// Delete a platform
export const deletePlatform = async (id) => {
  try {
    const response = await fetch(`${API_URL}/plateform/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return true; // Successfully deleted
  } catch (error) {
    console.error(`Error deleting platform ${id}:`, error);
    throw error;
  }
};

export const getAllPlatforms = async () => {
  try {
    const response = await fetch(`${API_URL}/plateform`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching all platforms:', error);
    throw error;
  }
};
